import React from 'react';
import { lazyGettext } from '@eb/lazy-gettext';
import {
    ABANDONED_ORDER_EMAILS,
    ALL_MAJOR_CREDIT_CARDS,
    ANALYTICS_BY_TICKET_TYPE,
    AT_THE_DOOR_SALES,
    ATTENDEE_CHECK_IN_VIA_APP,
    ATTENDEE_SHARING_TOOLS,
    AUTOMATED_SOCIAL_NOTIFICATIONS,
    BADGE_PRINTING_INTEGRATIONS,
    BRANDED_IMG_ON_TICKETS,
    COMMUNITY_PAGES,
    CROSS_EVENT_ANALYTICS,
    CUSTOM_URL,
    CUSTOMIZABLE_ATTENDEE_INFO,
    CUSTOMIZABLE_ORDER_CONFIRMATION,
    DETAILED_EXPORTS,
    DIGITAL_TICKETS,
    DIRECT_DEPOSIT_OR_CHECK,
    DISCOUNT_AND_ACCESS_CODES,
    DONATION_COLLECTION,
    EMAIL_INVITATIONS,
    FUNDRAISING_INTEGRATIONS,
    GOOGLE_ANALYTICS_INTEGRATION,
    GROUP_REGISTRATION,
    INDUSTRY_LEADING_SEARCH,
    MARKETING_INTEGRATIONS,
    MOBILE_OPTIMIZED_PURCHASE_FLOW,
    MOBILE_ORGANIZER_APP,
    MOBILE_TICKETS,
    ON_SITE_APP_INTEGRATIONS,
    ON_SITE_CONSULTATION_LANDING_PAGE,
    ON_SITE_STAFFING_LANDING_PAGE,
    OPEN_API,
    PARTNER_DISTRIBUTION,
    PASS_ON_FEES,
    PAYMENT_PROCESSING,
    PCI_COMPLIANT,
    PRICE_PER_FREE_TICKET,
    PRIVATE_EVENTS,
    PRODUCT_TRAINING,
    PUBLIC_EVENTS,
    PUBLIC_LISTINGS,
    RECURRING_EVENTS,
    REGISTRATION_TRANSFERS,
    RENTAL_EQUIPMENT_LANDING_PAGE,
    RESERVED_SEATING,
    SALES_RSVP_DASHBOARD,
    SECURE_PAYMENT_PROCESSING,
    SELF_SERVICE_TRACKING_PIXELS,
    SELL_ON_YOUR_WEBSITE,
    SESSION_MANAGEMENT_INTEGRATIONS,
    STANDARD_CHECKOUT_FORM,
    SURVEY_INTEGRATIONS,
    TEAM_ACCESS_AND_PERMISSIONS,
    TICKET_SCANNING_VIA_APP,
    TICKET_TYPES,
    TICKETS_ON_FACEBOOK,
    UNLIMITED_EVENTS,
    WAITLISTS,
} from '../../constants/featuresComparison';
import { SIGNUP_CTAS } from '../../constants/main';
import { STYLE_ANCHOR } from '@eb/eds-button';

import { Ticket } from '@eb/eds-iconography';
import { Megaphone } from '@eb/eds-iconography';
import { LineChart } from '@eb/eds-iconography';
import { ScanCheck } from '@eb/eds-iconography';
import { Lock } from '@eb/eds-iconography';
import { Headphone } from '@eb/eds-iconography';

export default {
    primaryHeading: lazyGettext("Choose the solution that's right for you"),
    paymentProcessingFeature: PAYMENT_PROCESSING,
    sections: {
        0: {
            heading: lazyGettext('Start Selling'),
            iconType: <Ticket />,
            features: [
                TICKET_TYPES,
                PUBLIC_EVENTS,
                PRIVATE_EVENTS,
                UNLIMITED_EVENTS,
                STANDARD_CHECKOUT_FORM,
                DIGITAL_TICKETS,
                MOBILE_TICKETS,
                DONATION_COLLECTION,
                PASS_ON_FEES,
                FUNDRAISING_INTEGRATIONS,
                RECURRING_EVENTS,
                CUSTOM_URL,
                WAITLISTS,
                AT_THE_DOOR_SALES,
                CUSTOMIZABLE_ATTENDEE_INFO,
                CUSTOMIZABLE_ORDER_CONFIRMATION,
                RESERVED_SEATING,
                REGISTRATION_TRANSFERS,
                GROUP_REGISTRATION,
                PRODUCT_TRAINING,
            ],
        },
        1: {
            heading: lazyGettext('Promote & Grow'),
            iconType: <Megaphone />,
            features: [
                MOBILE_OPTIMIZED_PURCHASE_FLOW,
                PUBLIC_LISTINGS,
                INDUSTRY_LEADING_SEARCH,
                AUTOMATED_SOCIAL_NOTIFICATIONS,
                ATTENDEE_SHARING_TOOLS,
                ABANDONED_ORDER_EMAILS,
                PARTNER_DISTRIBUTION,
                TICKETS_ON_FACEBOOK,
                EMAIL_INVITATIONS,
                DISCOUNT_AND_ACCESS_CODES,
                MARKETING_INTEGRATIONS,
                SELL_ON_YOUR_WEBSITE,
                BRANDED_IMG_ON_TICKETS,
                COMMUNITY_PAGES,
            ],
        },
        2: {
            heading: lazyGettext('Track & Optimize'),
            iconType: <LineChart />,
            features: [
                SALES_RSVP_DASHBOARD,
                DETAILED_EXPORTS,
                MOBILE_ORGANIZER_APP,
                GOOGLE_ANALYTICS_INTEGRATION,
                SURVEY_INTEGRATIONS,
                SELF_SERVICE_TRACKING_PIXELS,
                CROSS_EVENT_ANALYTICS,
                ANALYTICS_BY_TICKET_TYPE,
            ],
        },
        3: {
            heading: lazyGettext('Streamline Operations'),
            iconType: <ScanCheck />,
            features: [
                TICKET_SCANNING_VIA_APP,
                ATTENDEE_CHECK_IN_VIA_APP,
                OPEN_API,
                BADGE_PRINTING_INTEGRATIONS,
                SESSION_MANAGEMENT_INTEGRATIONS,
                ON_SITE_APP_INTEGRATIONS,
                ON_SITE_CONSULTATION_LANDING_PAGE,
                ON_SITE_STAFFING_LANDING_PAGE,
                RENTAL_EQUIPMENT_LANDING_PAGE,
                TEAM_ACCESS_AND_PERMISSIONS,
            ],
        },
        4: {
            heading: lazyGettext('Stay Secure'),
            iconType: <Lock />,
            features: [
                ALL_MAJOR_CREDIT_CARDS,
                PCI_COMPLIANT,
                DIRECT_DEPOSIT_OR_CHECK,
                SECURE_PAYMENT_PROCESSING,
                // EARLY_PAYOUTS, Temp Removing this for COVID-19
                // CUSTOM_PAYOUT_SCHEDULE, Temp removed for COVID-19
            ],
        },
    },
    CTAs: SIGNUP_CTAS,
    CTAStyles: [STYLE_ANCHOR, STYLE_ANCHOR, STYLE_ANCHOR],
    pricePerFreeTicket: PRICE_PER_FREE_TICKET,
    showMaxFee: false,
};
